import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { get } from 'lodash';

import { colors } from '../../styles';
import Button from './Button';
import icons from '../IconsList';

const styles = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 93px;
  z-index: 101;
  @media(min-width: 992px) {
    height: 185px;
  }
  &.HeaderAlt {
    background-color: ${colors.color2};
  }
  .HeaderLogo_wrapper {
    width: 200px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    @media(min-width: 992px) {
      width: 240px;
    }
    @media(min-width: 1300px) {
      width: 380px;
    }
    .HeaderLogo {
      width: 170px;
      @media(min-width: 992px) {
        width: 200px;
      }
      @media(min-width: 1300px) {
        width: 300px;
      }
    }
  }
  .HeaderLink_wrapper {
    padding: 0 120px 0 0;
    margin: 0;
    justify-content: flex-end;
    @media(min-width: 1300px) {
      padding: 0 180px 0 0;
    }
    li {
      & + li {
        padding-left: 20px;
        @media(min-width: 1300px) {
          padding-left: 40px;
        }
      }
    }
    .HeaderLink_item {
      font-weight: 500;
      font-size: 15px;
      color: #FFFFFF;
      letter-spacing: 2.5px;
      text-align: center;
      text-transform: uppercase;
      transition: all .3s ease-out;
      &:hover {
        color: ${colors.color1};
      }
    }
  }
`;

function Header({ headerAlt, toggleHeaderLinks, headerLinks }) {
  return (
    <div className={`${styles} ${headerLinks ? 'HeaderAlt' : ''}`}>
      <div className="d-flex align-items-center h-100">
        <Link name="index" className="HeaderLogo_wrapper">
          <img src={get(icons, 'logo')} alt="Logo Arjen Homes" className="HeaderLogo" />
        </Link>
        <ul className={`flex-fill d-none HeaderLink_wrapper list-unstyled ${headerLinks ? 'd-none' : 'd-lg-flex'}`}>
          {/* <li>
            <Link name="homes" className="HeaderLink_item">Modern Homes</Link>
          </li> */}
          <li>
            <Link name="homes" className="HeaderLink_item">Available Homes</Link>
          </li>
          <li>
            <Link name="about-us" className="HeaderLink_item">About Us</Link>
          </li>
          <li>
            <Link name="contact-us" className="HeaderLink_item">Contact</Link>
          </li>
        </ul>
        <Button headerAlt={headerAlt} toggleHeaderLinks={toggleHeaderLinks} />
      </div>
    </div>
  );
}

Header.propTypes = {
  headerAlt: PropTypes.bool.isRequired,
  headerLinks: PropTypes.bool.isRequired,
  toggleHeaderLinks: PropTypes.func.isRequired,
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/PageWrapper/Header.js